import React from "react";
import { SBBox } from "modules/Commons";
import { SBNewTable } from "modules/Commons/SBDataDisplays/SBTable/SBNewTable";
import { IConfigCSVErrors } from "domain/Config/Models/IConfigCSVErrors";
import { useStyles } from "../style";
import { useInventoryPositionUploadErrorsHeader } from "./useInventoryPositionUploadErrorsHeader";

interface InventoryPositionUploaderHelperErrorProps {
	errors: IConfigCSVErrors[];
}

const InventoryPositionUploaderHelperError: React.FC<
	InventoryPositionUploaderHelperErrorProps
> = ({ errors }) => {
	const classes = useStyles();
	const { headers } = useInventoryPositionUploadErrorsHeader();

	return (
		<SBBox className={classes.errorsTableContainer}>
			<SBNewTable
				key={errors.length}
				startRows={errors}
				defaultColumns={headers}
				onClick={() => {}}
				title="errors"
				disableToolbar
				virtualize
				containerHeight={295}
			/>
		</SBBox>
	);
};

export default InventoryPositionUploaderHelperError;
